import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import axios from 'axios';

axios.defaults.headers.get['ngrok-skip-browser-warning'] = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
axios.defaults.headers.get['ngrok-skip-browser-warning'] = true;

const sessionId = localStorage.getItem('sessionId');
axios.defaults.headers.common['x-session-id'] = sessionId;

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
